<template>
  <div class="add-group-member container">
    <div class="row pt-4 mb-3">
      <div class="col-12">
        <div style="margin-bottom: 24px;">
          <a class="back-button" href="/team-members/teams">
            <img
                v-bind:src="'/images/arrow_back_blue.svg'"
                alt
                style="margin: 0 4px 4px 0;"
            />
            Back to Teams
          </a>
        </div>
      </div>
    </div>
    <div style="padding-bottom: 50px;max-width: 768px;margin: 0 auto;">
      <div class="row mb-4">
        <div class="col-12">
          <div class="add-group-member__title">
            {{ groupData.name }} Team
          </div>
        </div>
        <div
            class="add-group-member__desc"
            v-if="canEdit"
        ></div>
        <div class="col-12">
          <p>{{ groupData.description }}</p>
        </div>
      </div>

      <div class="row">
        <div class="col-12 d-flex justify-content-between pb-4">
          <div class="all-members">All Members</div>
          <div class="d-flex align-items-center ">
            <a
                href="javascript:void(0);"
                data-toggle="modal"
                data-target="#add-group-members-modal"
                v-if="canEdit"
                class="add-group-member__add"
            >
              <i class="fas fa-plus"></i>
              Add
            </a>
            <a
                :href="`/groups/${groupData.id}`"
                class="ml-3 add-group-member__add"
            >
              <i class="fas fa-edit"></i>
              Edit</a
            >
            <button
                @click="promptDeleteTeam"
                class="ml-3 add-group-member__add"
            >
              <i class="fas fa-trash"></i>
              Delete
            </button
            >
          </div>
        </div>
      </div>

      <div class="row" style="min-height: 340px;">
        <div class="col-12">
          <div class="d-flex py-2 mb-1" v-for="member in displayMembers">
            <div class="mr-2 align-self-center">
              <user-avatar :avatarURL="member.avatar_src"></user-avatar>
            </div>
            <div class="px-1 align-self-center" style="flex:7;">
              <div class="name">{{ member.display_name || member.name }}</div>
              <div
                  class="designation"
                  v-text="userDesignation(member)"
              ></div>
              <div
                  v-bind:class="{
                                    name: !(
                                        member.display_name || member.name
                                    ),
                                    sub:
                                        member.display_name || member.name
                                }"
                  v-text="member.email"
              ></div>
            </div>
            <div class="align-self-center">
              <selection-button
                  :active="isCollaborator(member)"
                  activeColor="#0f0f0f"
                  activeContent="Revoke collaborator access"
                  inactiveContent="Give collaborator access"
                  @change="handleCollaborator(member)"
              ></selection-button>
            </div>
          </div>
          <empty-state
              v-if="members.length === 0"
              :page="'staff'"
          ></empty-state>
        </div>
      </div>

      <div
          class="col-md-12 d-flex justify-content-center pagination-section"
          v-if="paginator.current_page < paginator.last_page"
      >
        <button
            type="button"
            class="btn wfh-link"
            @click="showMoreMembers"
        >
          Show More
        </button>
      </div>

      <div
          class="modal fade"
          id="add-group-members-modal"
          tabindex="-1"
          role="dialog"
          aria-hidden="true"
      >
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header d-none d-sm-block border-0 p-0">
              <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
              >
                &times;
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-group mb-0">
                    <label for="add-members">Add Members</label>
                    <div
                        class="position-relative search-wrapper"
                    >
                      <input
                          type="text"
                          class="form-control search-input"
                          id="add-members"
                          placeholder="Search by name, title"
                          v-model="q"
                      />
                      <i
                          class="fas fa-search"
                          style="color: #303030;"
                      ></i>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-12 pb-4 mt-2" style="height: 380px;overflow: scroll;" ref="staffListContainer">
                  <div
                      class="d-flex mt-3 justify-content-between"
                      v-for="(staff, key) in staffs"
                  >
                    <div class="d-flex">
                      <div class="mr-2 align-self-center">
                        <user-avatar :avatarURL="staff.avatar_src"></user-avatar>
                      </div>

                      <div class="px-1 align-self-center">
                        <div
                            class="modal-name"
                            v-text="
                                                    staff.display_name ||
                                                        staff.name
                                                "
                        ></div>
                        <div
                            class="modal-designation"
                            v-text="userDesignation(staff)"
                        ></div>
                        <div
                            class="modal-email"
                            v-bind:class="{
                                                    name: !(
                                                        staff.display_name ||
                                                        staff.name
                                                    ),
                                                    sub:
                                                        staff.display_name ||
                                                        staff.name
                                                }"
                            v-text="staff.email"
                        ></div>
                      </div>
                    </div>
                    <div class="px-1">
                      <button
                          class="btn btn-add"
                          @click="addMember(staff)"
                          v-if="!memberAdded(staff)"
                      >
                        Add
                        <i class="fas fa-plus"></i>
                      </button>
                      <button
                          class="btn btn-added"
                          @click="removeMember(staff)"
                          v-else
                      >
                        Added
                        <img
                            v-bind:src="'/images/added.png'"
                            alt
                            style="width: 14px;padding-bottom: 3px;"
                        />
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col text-center mb-2">
                  <button
                      type="button"
                      class="btn wfh-link"
                      @click="showMore"
                      :disabled="this.staffsPaginator.current_page === this.staffsPaginator.last_page"
                  >
                    Show More
                  </button>
                </div>
              </div>

              <div class="row">
                <div class="col-12 text-center">
                  <button
                      class="btn btn-done"
                      @click="saveMembers()"
                  >
                    Done
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <DeleteTeamPromptModal
        v-if="deletingTeam"
        :deleteTeamName="groupData.name"
        @close="resetForm"
        @confirm="deleteTeam"
    />
  </div>
</template>

<script>
import DeleteTeamPromptModal from '../../Misc/Modal/DeleteTeamPromptModal';

export default {
  components: { DeleteTeamPromptModal },
  props: ['group'],

  data () {
    return {
      groupData: {},
      staffs: [],
      members: new Map(),
      displayMembers: [],
      paginator: {
        from: 1,
        last_page: 1,
        per_page: 50,
        to: 4,
        total: 4,
        current_page: 1,
      },
      q: '',
      staffsPaginator: {
        from: 1,
        last_page: 1,
        per_page: 5,
        to: 4,
        total: 4,
        current_page: 1,
      },
      checkDivReady: null,
      removing: new Map(),
      newMembers: new Map(),
      deletingTeam: false,
    };
  },

  computed: {
    currentUser () {
      return this.$store.state.currentUser;
    },

    canEdit () {
      return Object.keys(JSON.parse(JSON.stringify(this.currentUser))).length > 0 ?
          (this.$store.state.isAdmin && this.currentUser?.status !== 'pending') : false;
    },
  },

  watch: {
    q () {
      this.executeSearch();
    },
  },

  methods: {
    showMoreMembers () {
      this.paginator.current_page++;
      this.getMembers();
    },

    executeSearch: _.debounce(async function () {
      this.staffs = [];
      this.staffsPaginator.current_page = 1,
      await this.getStaffs();
    }, 500),

    memberAdded (staff) {
      return (
          (this.members.has(staff.id) || this.newMembers.has(staff.id)) &&
          !this.removing.has(staff.id)
      );
    },

    addMember (staff) {
      if (!this.members.has(staff.id) && !this.newMembers.has(staff.id)) {
        this.newMembers = new Map(this.newMembers.set(staff.id, staff));
      }

      if (this.removing.has(staff.id)) {
        let tempMap = this.removing;
        tempMap.delete(staff.id);
        this.removing = new Map(tempMap);
      }
    },

    removeMember (staff) {
      if (this.members.has(staff.id)) {
        this.removing = new Map(this.removing.set(staff.id, staff));
      }

      if (this.newMembers.has(staff.id)) {
        let tempMap = this.newMembers;
        tempMap.delete(staff.id);
        this.newMembers = new Map(tempMap);
      }
    },

    async getMembers () {
      const response = await axios.get(`/groups/${this.groupData.id}/members`, {
        params: {
          page: this.paginator.current_page,
          per_page: this.paginator.per_page,
        },
      });
      const data = response.data;

      data.data.forEach(member => {
        this.displayMembers.push(member);
        this.members.set(member.id, member);
      });

      Object.keys(this.paginator).forEach(key => {
        this.paginator[key] = data[key];
      });
    },

    showMore () {
      if (this.staffsPaginator.current_page < this.staffsPaginator.last_page) {
        this.staffsPaginator.current_page++;
        this.getStaffs();
      }
    },

    async getStaffs () {
      const res = await axios.get('/team-members/add-list', {
        params: {
          q: this.q,
          page: this.staffsPaginator.current_page,
          per_page: this.staffsPaginator.per_page,
        },
      });
      const responseData = res.data.data;
      const responseMeta = res.data;

      this.staffs = this.staffs.concat(responseData);

      [
        'from',
        'last_page',
        'per_page',
        'to',
        'total',
      ].forEach(key => this.staffsPaginator[key] = responseMeta[key]);

      this.checkDivReady = setInterval(this.scrollTheListDown, 10);
    },

    scrollTheListDown () {
      const totalNodes = this.$refs['staffListContainer'].childNodes.length;

      if (this.$refs['staffListContainer'].childNodes[totalNodes - 1]) {
        if (totalNodes > 5) {
          this.$refs['staffListContainer'].childNodes[totalNodes - 1].scrollIntoView(
              { block: 'end', behavior: 'smooth' });
        }

        clearInterval(this.checkDivReady);
      }
    },

    async saveMembers () {
      if (this.removing.size > 0) {
        this.removing.forEach(member => {
          axios.delete(
              `/groups/${this.groupData.id}/members/${member.id}`,
          );
        });
      }

      let payload = [];

      [...this.newMembers.values()].forEach(member => {
        payload.push(member.id);
      });

      if (payload.length > 0) {
        const url = `/groups/${this.groupData.id}/members`;
        await axios.post(url, {
          members: payload,
        });
      }

      location.reload();
    },

    isEmptySearchResults () {
      return this.staffs.length === 0 && !!this.q;
    },

    userDesignation (staff) {
      if (!staff.role) {
        return 'Team Member';
      }

      return staff.role.slug === 'freelancer' ? 'External' : staff.designation;
    },

    isCollaborator (staff) {
      return staff.groups[0].pivot.role === 'collaborator';
    },

    promptDeleteTeam () {
      this.deletingTeam = true;
      this.delete;
    },

    resetForm () {
      this.deletingTeam = false;
    },

    async deleteTeam () {
      await axios.delete(`/groups/${this.groupData.id}`);

      location.href = '/team-members/teams';
    },

    async handleCollaborator (member) {
      const payload = this.isCollaborator(member) ? {} : {role: 'collaborator'};
      await axios.put(`/groups/${this.groupData.id}/members/${member.id}`, payload);

      if (Object.keys(payload).length === 0) {
        member.groups[0].pivot.role = null;
        return;
      }

      member.groups[0].pivot.role = 'collaborator';
    },
  },

  mounted () {
    this.groupData = JSON.parse(this.group);
    this.getMembers();
    this.getStaffs();
  },
};
</script>

<style scoped lang="scss">
.add-group-member {
  .back-button {
    color: #0db4e6;
    font-family: "Open Sans", sans-serif;
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
  }

  &__title {
    color: #303030;
    font-family: Lato;
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 53.2px;
    text-align: center;
  }

  &__desc {
    color: #606064;
    font-family: "Open Sans", sans-serif;
    font-size: 20px;
    letter-spacing: 0;
    line-height: 28px;
    text-align: center;
  }

  .all-members {
    color: #303030;
    font-family: Lato;
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 28px;
  }

  &__add {
    background: none;
    border: none;
    color: #303030;
    font-family: "Open Sans", sans-serif;
    font-size: 16px;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 22px;

    @media (max-width: 768px) {
      text-align: left;
      font-size: 14px;
    }

    i {
      color: #3592ff;
    }
  }

  .card {
    .name {
      color: #303030;
      font-family: "Open Sans", sans-serif;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
      line-height: 22px;
    }
  }

  .modal-content {
    position: relative;

    .close {
      position: absolute;
      top: 0;
      right: 0;
      background: linear-gradient(135deg, #000 0%, #28282e 100%);
      border-radius: 100%;
      height: 40px;
      width: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      opacity: 1;
      color: white;
    }

    label {
      color: #303030;
      font-family: Lato;
      font-size: 20px;
      font-weight: bold;
      letter-spacing: 0;
      line-height: 28px;
    }

    .modal-name {
      color: #303030;
      font-family: "Open Sans";
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0;
      /* line-height: 22px; */
    }

    .modal-designation {
      color: #303030;
      font-family: "Open Sans";
      font-size: 10px;
      letter-spacing: 0;
      /* line-height: 22px; */
    }

    .modal-email {
      color: #808fa4;
      font-family: "Open Sans";
      font-size: 10px;
      letter-spacing: 0;
      /* line-height: 22px; */
    }
  }

  .search-wrapper {
    .search-input {
      font-size: 16px;
      letter-spacing: 0;
      line-height: 24px;
      border: 1px solid #dce2ed !important;
      background: white;
      padding-left: 2rem;
    }

    .fa-search {
      color: rgb(48, 48, 48);
      position: absolute;
      top: 4px;
      display: flex;
      width: 32px;
      height: 32px;
      align-items: center;
      justify-content: center;
    }
  }

  .btn-done {
    height: 56px;
    width: 280px;
    color: #fff;
    font-family: "Open Sans";
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 22px;
    text-align: center;
    background: #000;
  }
}

.form-control wfh-version {
  border-radius: 3px;
  background-color: #f2f2f2;
  border: none;
}

:disabled {
  cursor: default;
}

.name {
  color: #303030;
  font-family: "Open Sans";
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 22px;
}

.designation {
  color: #303030;
  font-family: "Open Sans";
  font-size: 10px;
  letter-spacing: 0;
  line-height: 22px;
}

.sub {
  color: #808fa4;
  font-family: "Open Sans";
  font-size: 10px;
  letter-spacing: 0;
  line-height: 22px;
}

:root {
  --avatar-size: 40px;
}

.btn-add {
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  color: #303030;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  /* line-height: 22px; */
  padding: 6px 8px 5px 8px !important;
  width: 70px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.btn-added {
  border-radius: 6px;
  background-color: #82df6b;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  color: #fff;
  font-family: "Open Sans";
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0;
  padding: 6px 8px 5px 8px !important;
  /* line-height: 22px; */
}

.btn-paginator {
  border-radius: 6px;
  background-color: #fff;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.09);
  border: none;
  color: #5145ff;
  font-weight: 700;
}

@media (max-width: 768px) {
  .modal-dialog {
    margin: 0;
    bottom: 0;
    position: absolute;
    left: 0;
    right: 0;
  }
}
</style>
